import './App.css';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Home from "./components/home/home";
import Success from "./components/success/success";
import React from "react";
import 'antd/dist/antd.css';
import {createBrowserHistory} from "history"; // or 'antd/dist/antd.less'
// import 'react-date-range/dist/styles.css'; // main style file
// import 'react-date-range/dist/theme/default.css'; // theme css file
const history = createBrowserHistory();
function App() {
    return (
        <Router history={history}>
            <div className="App">
                {/*<header className="App-header">*/}
                {/*  <img src={logo} className="App-logo" alt="logo" />*/}
                {/*  <p>*/}
                {/*    Edit <code>src/App.js</code> and save to reload.*/}
                {/*  </p>*/}
                {/*  <a*/}
                {/*    className="App-link"*/}
                {/*    href="https://reactjs.org"*/}
                {/*    target="_blank"*/}
                {/*    rel="noopener noreferrer"*/}
                {/*  >*/}
                {/*    Learn React*/}
                {/*  </a>*/}
                {/*</header>*/}
                <Switch>
                    <Route exact path='/' component={Home}/>
                    <Route exact path='/success' component={Success}/>
                </Switch>
            </div>
        </Router>
    );
}

export default App;
